import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PivotSpinnerComponent } from './pivot-spinner.component';
import { PivotSpinnerDirective } from './pivot-spinner.directive';

@NgModule({
  declarations: [PivotSpinnerComponent, PivotSpinnerDirective],
  exports: [
    PivotSpinnerComponent,
    PivotSpinnerDirective,
  ],
  imports: [
    CommonModule,
  ],
  entryComponents: [PivotSpinnerComponent],
})
export class PivotSpinnerModule {
}
